import 'styles/main'

import Layout from 'components/Layout'
import Error from 'views/Error'

import Header from 'components/Header'
import Footer from 'components/Footer'
import HomeTeaser from 'components/HomeTeaser'

import { mapState, mapGetters } from 'vuex'

export default {
  name: 'App',
  metaInfo: {
    title: 'frischer wind',
    titleTemplate: '%s | frischer wind',
  },
  data: () => ({
    UABrowser: '',
  }),
  created() {
    const urlLangDetected = this.$route.path.startsWith('/en') ? 'en' : 'de'
    this.$store.dispatch('loadData', urlLangDetected).then(() => {
      window.prerenderReady = true
    })
    this.detectBrowser()
  },
  computed: {
    ...mapState(['error']),
    ...mapGetters(['currentPage']),
  },
  watch: {
    $route: 'resetErrors',
  },
  methods: {
    resetErrors() {
      this.$store.dispatch('resetError')
    },
    detectBrowser() {
      const parse = require('ua-parser-js')
      const ua = parse(navigator.userAgent)
      this.UABrowser = ua.browser.name + ua.browser.major
    },
  },
  render(h) {
    return (
      <div
        class={`App is-page-${this.currentPage.slug} is-${this.UABrowser}`}
        id="app"
      >
        <Header />
        <Layout>
          <transition name="u-anim-slide-fade-left">
            {this.error.status ? (
              <Error />
            ) : (
              <router-view key={this.$route.fullPath} />
            )}
          </transition>
        </Layout>
        <HomeTeaser show={this.$route.name === 'Home'} />
        <Footer />
      </div>
    )
  },
}



// WEBPACK FOOTER //
// ./client/views/App/index.js